import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    isShowPreview: false,
    menuList: [],
    currentSubMenu: [],
    useTipsDialogVisible: false,
    hasInit: false,
    isXbbIframeShow: false,
    isBannerVisible: false,
    hardwareUploadShow: false,
    hardwareUploadShowList: false,
    defaultMenu: [],
    thirdAppKey: '',
    keepAlivePages: [], // 需要keep-alive缓存的页面列表
    isGetBoardMenu: false,
    isGetChatMenu: false,
    chatMenuList: [],
    speakFile: null,
    shouldOpenQuickOperate: false,
    quickThirdImport: false,
    aiInitIsCompleted: null,
    aiInitConfigDetails: [],
    isAiInitialization: null,
    aiOpenSessionId: null,
    aiSalesMentorSession: null,
    sidebarCollapsed: false,
    isMenuOpen: false, // 移动端侧拉菜单展开状态
    aiAgentQuickOpen: null, // 来自 ai-board 的 aiAgentQuickOpen 消息数据
    isPopup: 0 // AI 初始化自动展示popup 1为显示 0为不显示
  }),

  actions: {
    setIsShowPreview(isShowPreview) {
      this.isShowPreview = isShowPreview
    },
    setMenuList(menuList) {
      this.menuList = menuList
    },
    setSubMenuList(menu) {
      this.currentSubMenu = menu
    },
    setuseTipsDialogVisible(useTipsDialogVisible) {
      this.useTipsDialogVisible = useTipsDialogVisible
    },
    setHasInit(isInit) {
      this.hasInit = isInit
    },
    setIsXbbIframeShow(isXbbIframeShow) {
      this.isXbbIframeShow = isXbbIframeShow
    },
    setIsBannerVisible(isBannerVisible) {
      this.isBannerVisible = isBannerVisible
    },
    setHardwareUploadShow(hardwareUploadShow) {
      this.hardwareUploadShow = hardwareUploadShow
    },
    setHardwareUploadShowList(hardwareUploadShowList) {
      this.hardwareUploadShowList = hardwareUploadShowList
    },
    setDefaultMenu(defaultMenu) {
      this.defaultMenu = defaultMenu
    },
    setThirdAppKey(thirdAppKey) {
      this.thirdAppKey = thirdAppKey
    },
    setKeepAlivePages(pages) {
      this.keepAlivePages = pages
    },
    addKeepAlivePage(page) {
      if (!this.keepAlivePages.includes(page)) {
        this.keepAlivePages.push(page)
      }
    },
    removeKeepAlivePage(page) {
      this.keepAlivePages = this.keepAlivePages.filter((p) => p !== page)
    },
    setIsGetBoardMenu(isGet) {
      this.isGetBoardMenu = isGet
    },
    setIsGetChatMenu(isGet) {
      this.isGetChatMenu = isGet
    },
    setChatMenuList(chatMenuList) {
      this.chatMenuList = chatMenuList
    },
    setSpeakFile(file) {
      this.speakFile = file
    },
    clearSpeakFile() {
      this.speakFile = null
    },
    setShouldOpenQuickOperate(shouldOpen) {
      this.shouldOpenQuickOperate = shouldOpen
    },
    setQuickThirdImport(quickThirdImport) {
      this.quickThirdImport = quickThirdImport
    },
    setAiInitIsCompleted(isCompleted) {
      this.aiInitIsCompleted = isCompleted
    },
    setAiInitConfigDetails(configDetails) {
      this.aiInitConfigDetails = configDetails
    },
    setAiInitialization(status) {
      this.isAiInitialization = status
    },
    setOpenAiSessionId(sessionId) {
      this.aiOpenSessionId = sessionId || ''
    },
    setAiSalesMentorSession(session) {
      this.aiSalesMentorSession = session || null
    },
    setSidebarCollapsed(sidebarCollapsed) {
      this.sidebarCollapsed = sidebarCollapsed
    },
    setIsMenuOpen(isMenuOpen) {
      this.isMenuOpen = isMenuOpen
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    setIsPopup(isPopup) {
      this.isPopup = isPopup
    },
    setAiAgentQuickOpen(data) {
      this.aiAgentQuickOpen = data ?? null
    }
  }
})
